class UnauthorisedError extends Error {
    constructor(message = 'Unauthorised') {
        super(message);
        this.name = 'UnauthorisedError';
        this.status = 401;
    }
}

export default UnauthorisedError;